import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import LaunchIcon from "@mui/icons-material/Launch";
import { RootState } from "..";
import { useEffect, useState } from "react";
import { DIALOGS, DIALOG_TYPES } from "../components/Dialogs/dialogReducer";

export const useSelectedRow = () => {
  const selectedRow = useSelector((state: RootState) => state.examOverview.selectedRow);
  const [item, setItem] = useState<{ id: string | null; name: string | null }>({ id: null, name: null });

  useEffect(() => {
    if (selectedRow) {
      setItem({ id: selectedRow.id, name: selectedRow.name });
    } else {
      setItem({ id: null, name: null });
    }
  }, [selectedRow]);

  return item;
};

export const useDocumentOptions = ({ openExam }: { openExam: (examId: string) => void }) => {
  const { id: itemId } = useSelectedRow();
  const dispatch = useDispatch();

  return [
    {
      title: "Öffnen",
      icon: <LaunchIcon />,
      action: () => openExam(itemId!),
      activeWhenNoValidLicense: false,
    },
    {
      title: "Umbenennen",
      icon: <EditIcon />,
      action: () => dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.RENAME_EXAM_DIALOG } }),
      activeWhenNoValidLicense: true,
    },
    {
      title: "Kopieren",
      icon: <ContentCopyIcon />,
      action: () => dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.COPY_EXAM_DIALOG } }),
      activeWhenNoValidLicense: false,
    },

    {
      title: "Verschieben",
      icon: <DriveFileMoveIcon />,
      action: () => dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.MOVE_EXAM_DIALOG } }),
      activeWhenNoValidLicense: true,
    },
    {
      title: "Löschen",
      icon: <DeleteIcon />,
      action: () => dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.DELETE_EXAM_DIALOG } }),
      activeWhenNoValidLicense: true,
    },
  ];
};

export const useFolderOptions = () => {
  const { name: itemName } = useSelectedRow();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const openFolder = () => {
    const pathString = decodeURI(location.pathname.replace("/exam-overview", "")) || "/";

    if (itemName) {
      const current = pathString + (pathString === "/" ? "" : "/");
      navigate("/exam-overview" + current + encodeURI(itemName));
    }
  };

  return [
    {
      title: "Öffnen",
      icon: <LaunchIcon />,
      action: () => openFolder(),
    },
    {
      title: "Umbenennen",
      icon: <EditIcon />,
      action: () => dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.RENAME_FOLDER_DIALOG } }),
    },
    {
      title: "Verschieben",
      icon: <DriveFileMoveIcon />,
      action: () => dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.MOVE_FOLDER_DIALOG } }),
    },
    {
      title: "Löschen",
      icon: <DeleteIcon />,
      action: () => dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.DELETE_FOLDER_DIALOG } }),
    },
  ];
};
